export default __webpack_public_path__ + "static/media/pwd_type_3_4.852a8e77.png";